import React, { useState } from 'react';
import {
	Container,
	TextInput,
	Textarea,
	Text,
	Button,
	Title,
	Notification,
} from '@mantine/core';
import api from '../../services/api'; // Adjust the path to your `api.ts`
import SEO from '../Layout/seo';

const ContactUs: React.FC = () => {
	const [form, setForm] = useState({ name: '', email: '', message: '' });
	const [success, setSuccess] = useState<string | null>(null);
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setSuccess(null);
		setError(null);

		try {
			const response = await api.post('/contact', form); 
			if (response.status === 200) {
				setSuccess('Your message has been sent successfully!');
				setForm({ name: '', email: '', message: '' });
			} else {
				setError('Something went wrong. Please try again later.');
			}
		} catch (err) {
			console.error('Error sending message:', err);
			setError(
				'Failed to send your message. Please check your details and try again.'
			);
		}
	};

	return (
		<div>
			<SEO
				title="Contact Scorpio Classics"
				description="Reach out to Scorpio Classics for inquiries about our classic motorbikes, vintage jukeboxes, metal signs, and memorabilia. We're here to assist you."
				keywords="contact Scorpio Classics, classic motorbikes inquiries, vintage collectibles contact"
				imageUrl="https://www.scorpioclassics.com/images/top_slider/slider2.png"
				slug="/about-us"
			/>
			<Container
				size="lg"
				py="xl">
				<Title
					order={2}
					mb="lg">
					Contact Us
				</Title>

				<Text mt="md">Have questions or need more information about our products? Contact Scorpio Classics today. Our team is ready to assist you with your inquiries about classic motorbikes, vintage jukeboxes, metal signs, and memorabilia.</Text>

				<Text mt="md">
					If you have any questions or would like to visit our showroom then
					please visit us at: Unit 4, Table Oak Farm, Table Oak Lane, Fen End,
					Kenilworth, CV81PX - Please call to make If you would rather chat call
					Daz on 07904585553.
				</Text>

				{success && (
					<Notification
						color="green"
						onClose={() => setSuccess(null)}>
						{success}
					</Notification>
				)}
				{error && (
					<Notification
						color="red"
						onClose={() => setError(null)}>
						{error}
					</Notification>
				)}

				<form onSubmit={handleSubmit}>
					<TextInput
						label="Name"
						value={form.name}
						onChange={(e) => setForm({ ...form, name: e.target.value })}
						required
						mt="md"
					/>
					<TextInput
						label="Email"
						type="email"
						value={form.email}
						onChange={(e) => setForm({ ...form, email: e.target.value })}
						required
						mt="md"
					/>
					<Textarea
						label="Message"
						value={form.message}
						onChange={(e) => setForm({ ...form, message: e.target.value })}
						required
						mt="md"
					/>
					<Button
						type="submit"
						fullWidth
						mt="lg">
						Send
					</Button>
				</form>
			</Container>
		</div>
	);
};

export default ContactUs;
